module.exports = __webpack_public_path__ + "static/media/Team 27 Pi 289099339_1320072415483443_1106134415495793056_n - Jerica Cabanit.ddf63d5e.jpg";